import { ApolloClient, HttpLink, InMemoryCache } from "@apollo/client"

import config from "../config"

export default (params?) => {
  const url = new URL(config.GATSBY_SHOPIFY_STOREFRONT_API_ENDPOINT)

  if (params) {
    Object.keys(params)
      .filter((k) => !!params[k])
      .forEach((k) => {
        url.searchParams.append(k, params[k])
      })
  }

  return new ApolloClient({
    cache: new InMemoryCache({
      typePolicies: {},
    }),
    link: new HttpLink({
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token":
          config.GATSBY_SHOPIFY_STOREFRONT_API_KEY,
      },
      uri: url.href,
    }),
  })
}
